import React, { Component } from "react"
import classnames from "classnames"

import styles from "./siteEntryComponent.less"

function getHostTail() {
  if (process.env.NODE_ENV === "development") {
    return ""
  }

  const parts = location.hostname.split(".")
  if (parts.length === 2 || parts.length === 3) {
    const firstIndex = parts.length - 2
    return [parts[firstIndex], parts[firstIndex + 1]].join(".").toLowerCase()
  } else {
    return ""
  }
}

class SiteEntryComponent extends Component {
  state = {
    url: "",
  }

  handleChangeUrl = (e) => {
    this.setState({ url: e.target.value.trim() })
  }

  handleInputEnter = (e) => {
    if (e.keyCode == "13" && !this.getIsInvalidUrl()) {
      this.handleEnterUrl()
    }
  }

  getIsInvalidUrl = () => {
    let regexp = /^[a-z-_]+$/i

    if (regexp.test(this.state.url)) {
      regexp = /^[-_]+$/i

      let url = this.state.url.split("")
      return url.length < 2 || regexp.test(url[0]) || regexp.test(url[url.length - 1])
    }
    return true
  }

  handleEnterUrl = () => {
    if (process.env.NODE_ENV === "development") {
      document.location.href = location.origin
    } else {
      document.location.href = `https://${this.state.url}.${getHostTail()}`
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.form}>
          <header>
            <div className={styles.logo} />
          </header>
          <div className={styles.title}> Sign in to your site </div>
          <div className={styles.enterText}>
            <div className={styles.fields}>
              <input
                data-qa="enter-url"
                autoFocus={true}
                className={styles.inputUrl}
                placeholder="enter your site's URL"
                onKeyDown={this.handleInputEnter.bind(this)}
                value={this.state.url}
                onChange={this.handleChangeUrl.bind(this)}
              />
              <span>{"." + getHostTail()}</span>
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <button
              data-qa="assessment-share"
              className={classnames(
                styles.button,
                this.getIsInvalidUrl.call(this) ? styles.disabled : null,
              )}
              disabled={this.getIsInvalidUrl.call(this)}
              onClick={this.handleEnterUrl.bind(this)}
              type="success">
              Continue
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default SiteEntryComponent
